import {
  AdminJobState,
  AdminJobStatus,
  BackfillJobReason,
} from "../../../services";
import { Tone } from "../styles";
import { JobAgeFilter, JobFilterOption, JobStateFilter } from "./types";

export const JOB_SEARCH_MAX_LENGTH = 100;
export const JOB_SEARCH_DEBOUNCE_MS = 300;

export const JOB_STATE_OPTIONS: JobFilterOption<JobStateFilter>[] = [
  { value: "all", label: "All states" },
  { value: "failed", label: "Failed" },
  { value: "coverage_blocked", label: "Coverage blocked" },
  { value: "rate_limited", label: "Rate limited" },
  { value: "partial", label: "Partial" },
  { value: "queued", label: "Queued" },
  { value: "running", label: "Running" },
  { value: "completed", label: "Completed" },
];

export const JOB_AGE_OPTIONS: JobFilterOption<JobAgeFilter>[] = [
  { value: "any", label: "Any age" },
  { value: "1", label: "At least 1 hour" },
  { value: "24", label: "At least 24 hours" },
];

export const JOB_STATUS_LABELS: Record<AdminJobStatus, string> = {
  pending: "Pending",
  processing: "Processing",
  coverage_blocked: "Coverage blocked",
  failed: "Failed",
  queued: "Queued",
  running: "Running",
  finalizing: "Finalizing",
  completed: "Completed",
  partial: "Partial",
  rate_limited: "Rate limited",
  exhausted: "Exhausted",
};

export const JOB_STATE_TONES: Record<AdminJobState, Tone> = {
  failed: "critical",
  coverage_blocked: "warning",
  rate_limited: "warning",
  partial: "warning",
  queued: "unknown",
  running: "unknown",
  completed: "healthy",
};

export const JOB_REASON_DESCRIPTIONS: Record<BackfillJobReason, string> = {
  PROVIDER_RATE_LIMITED: "The provider's request limit was reached.",
  PROVIDER_UNAVAILABLE: "The price provider could not be reached.",
  PRICE_BASIS_UNVERIFIED:
    "The provider's prices could not be confirmed as split-adjusted closes.",
  VENUE_MISMATCH:
    "The provider lists this symbol on another exchange. Check the instrument's exchange.",
  MANUAL_PRICING_ONLY:
    "This instrument is priced manually, so its prices have to be entered.",
  PROVIDER_SYMBOL_UNKNOWN:
    "The instrument has no confirmed provider symbol, so no request was made.",
  FX_RATE_UNAVAILABLE: "An exchange rate needed for these prices was missing.",
  EXCHANGE_TIMEZONE_UNAVAILABLE:
    "The exchange's timezone is unknown, so closes could not be dated.",
  NO_PROVIDER_DATA_FOR_RANGE:
    "The provider has no prices for some of the requested months.",
  FINALIZATION_FAILED:
    "Prices were saved, but updating accounts and snapshots did not finish.",
  WORKER_INTERRUPTED: "The worker stopped before finishing this job.",
};
